import { render, staticRenderFns } from "./smart-diagnose-alert.vue?vue&type=template&id=03cf577a&scoped=true"
import script from "./smart-diagnose-alert.vue?vue&type=script&lang=js"
export * from "./smart-diagnose-alert.vue?vue&type=script&lang=js"
import style0 from "./smart-diagnose-alert.vue?vue&type=style&index=0&id=03cf577a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf577a",
  null
  
)

export default component.exports